import { Log } from 'probe.gl';
export default new Log({
  id: 'luma'
}).enable();
//# sourceMappingURL=log.js.map